<span class='bookmarkStar'
    [class.isSelected]='isSelected'
    [class.inDetail]='isDetail'
    (click)='switch()'></span>
